const BARE_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

interface Named {
  title: string;
  metadata?: { projectTitle?: string } | null;
}

/**
 * The name a project goes by on its card. A new project's state.json is titled with an internal id until something names
 * it, and opening the project copies that into metadata.projectTitle, so a video that never reached a plan would be
 * called by that id.
 */
export function projectName(conv: Named, outlineTitle?: string | null): string {
  const projectTitle = conv.metadata?.projectTitle;
  return outlineTitle || (projectTitle && !BARE_ID.test(projectTitle) ? projectTitle : conv.title);
}
